export default __webpack_public_path__ + "static/media/magnifier-question.34784372.svg";